import { PartialCarConfiguration } from '~/app/market-config/models/car-confi-market-configuration';
import { PartialUiConfiguration } from '~/app/market-config/models/car-confi-ui-configuration';

export const local: PartialCarConfiguration = {
	hasJetStream: false,
	enableFinancingServices: false,
	hideMonthlyRates: true,
	showPrices: false,
	hasTechnicalDataEnabled: false,
	showCaESummaryText: true,
	hideConsumptionEmissionEngineName: false,
	enable3d: false,
	stockCarConfig: {
		enabled: false,
		geoFilter: false,
		disclaimer: false,
		subheader: false,
		url: '',
		priceFilter: { min: 0, max: 0 },
		pricedisclaimer: false,
	},
};

export const local_ui: PartialUiConfiguration = {
	showAccessoriesInclusive: false,
};
